module.exports = __webpack_public_path__ + "static/media/circle.9c343e1a.svg";